// extracted by mini-css-extract-plugin
module.exports = {"addressContainer":"DeliveryAddress_addressContainer__3iK5M","inputField":"DeliveryAddress_inputField__18o4e","addButton":"DeliveryAddress_addButton__1M_j0"};